import { create } from 'apisauce';

let baseURL = 'https://owlichat.superlogica.com/';

if (window.__DEV__) {
    baseURL = 'http://localhost:8000/';
}

const api = create({ baseURL });

export default api;

export * from './contacts';



// WEBPACK FOOTER //
// ./src/api/index.js